<template>
  <span v-if="show" class="kt-font-danger validate-error">
    {{ error }}
  </span>
</template>

<script>
export default {
  name: 'ErrorMessage',
  props: {
    error: {
      default: '',
      type: String,
    },
    show: {
      default: false,
      type: Boolean,
    },
  },
};
</script>

<style scoped></style>
